module.exports = __webpack_public_path__ + "img/logo-sm-dark.69aba05d.png";